// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const bronzor: PokeData = {
  "id": 436,
  "name": "bronzor",
  "height": 5,
  "weight": 605,
  "base_experience": 60,
  "types": [
    PokeType.STEEL,
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "tackle",
    "confusion",
    "hypnosis",
    "confuse-ray",
    "psywave",
    "feint-attack",
    "safeguard",
    "future-sight",
    "imprison",
    "metal-sound",
    "extrasensory",
    "iron-defense",
    "gyro-ball",
    "payback",
    "heal-block",
    "flash-cannon",
    "heavy-slam",
    "hex"
  ],
  "moves": [
    "tackle",
    "confuse-ray",
    "psywave",
    "future-sight",
    "metal-sound",
    "metal-burst",
    "steel-beam",
    "psychic",
    "kinesis",
    "zen-headbutt",
    "reflect",
    "scrap-throw",
    "psy-pulse"
  ],
  "evolution_chain": {
    "id": 224,
    "item": null,
    "species": [
      {
        "name": "bronzor",
        "order": 460,
        "types": [
          PokeType.STEEL,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "bronzong",
        "order": 461,
        "types": [
          PokeType.STEEL,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 436,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 33,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 71.5,
    "speed": 23,
    "ability_power": 24
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
